import type {
  InboxWorkflowCellComponent,
  InboxWorkflowTableStepConfig,
} from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import LetterPrintModeCell from "./_modules/letter-print-mode-cell"
import LetterPrintOrderCell from "./_modules/letter-print-order-cell"
import LetterPrintRecipientChoiceCell from "./_modules/letter-print-recipient-choice-cell"
import LetterPrintScheduleCell from "./_modules/letter-print-schedule-cell"
import {
  DestinationAddressCell,
  RecipientEditor,
  recipientEditorActions,
  recipientEditorReason,
} from "./_modules/letter-recipient-editor"
import LetterSelectionPreconfiguration from "./_modules/letter-selection-preconfiguration"
import { rowSelectionValidationMessage } from "../../_shared/_logic/print-selection"
import { column, partialMessage } from "../../../../_shared/_logic/registry-composition"
import type {
  LetterSelectionCommitPayload,
  LetterSelectionDraft,
  LetterSelectionPreviewPayload,
  LetterSelectionRow,
} from "./contract"
import { buildLetterSelectionPayload } from "./_logic/payload"
import { LETTER_SELECTION_PREVIEW_KIND, parseLetterSelectionPreview } from "./_logic/preview"
import { buildLetterSelectionRows, createLetterSelectionDraft } from "./_logic/tableRows"

export const letterSelectionCells: Record<string, InboxWorkflowCellComponent> = {
  letterPrintMode: LetterPrintModeCell,
  letterPrintOrder: LetterPrintOrderCell,
  letterPrintRecipientChoice: LetterPrintRecipientChoiceCell,
  letterPrintSchedule: LetterPrintScheduleCell,
  letterDestinationAddress: DestinationAddressCell,
}

export const createLetterSelectionStep = (): InboxWorkflowTableStepConfig<
  LetterSelectionRow,
  LetterSelectionDraft,
  LetterSelectionCommitPayload,
  LetterSelectionPreviewPayload
> => ({
  kind: "table",
  preview: {
    kind: LETTER_SELECTION_PREVIEW_KIND,
    parse: parseLetterSelectionPreview,
    errorMessage: "Terminbrief-Auswahl konnte nicht geladen werden.",
  },
  columns: [
    column("mode", "Strategie", "letterPrintMode"),
    column("order", "Auftrag", "letterPrintOrder"),
    column("recipientChoice", "Empfänger", "letterPrintRecipientChoice"),
    column("destinationAddress", "Zieladresse", "letterDestinationAddress"),
    column("appointment", "Termin", "letterPrintSchedule", { isPrimary: true }),
  ],
  buildRows: ({ workflow, step, stepPreview, rowOutcomes, stepPreviewLoading, stepPreviewError }) =>
    buildLetterSelectionRows({
      workflow,
      step,
      preview: stepPreview,
      rowOutcomes,
      previewLoading: stepPreviewLoading,
      previewError: stepPreviewError,
    }),
  draft: {
    create: createLetterSelectionDraft,
    validate: (row, draft) =>
      rowSelectionValidationMessage(row, draft, {
        inferModeFromName: true,
      }),
  },
  rowEditor: RecipientEditor,
  rowEditorTitle: "Zieladresse bearbeiten",
  editorDisabledReason: ({ row, draft }) => recipientEditorReason(row, draft),
  rowActions: recipientEditorActions,
  preconfiguration: LetterSelectionPreconfiguration,
  buildPayload: buildLetterSelectionPayload,
  commit: {
    label: "Briefauswahl bestätigen",
    successMessage: "Briefauswahl wurde bestätigt.",
    partialMessage,
  },
})
